import { toWesternDigits } from './text';

/**
 * Identifiers people copy and paste to find a record (doc 56): arqam's ids
 * (UUIDs), receipt numbers, letter references.
 */

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

export const isUuid = (text: string) =>
  new RegExp(`^${UUID.source}$`, 'i').test(text.trim());

/** The first id in what was pasted: an id, or a link that contains one. */
export function findUuid(text: string): string | null {
  return UUID.exec(text)?.[0].toLowerCase() ?? null;
}

/** «3f2a1b9c»: enough to recognize a record; the tag copies the full id. */
export const shortId = (id: string) => id.slice(0, 8);

/** A receipt number as arqam writes it ("2026-00042"), from "2026-42". */
export function receiptNo(text: string): string | null {
  const m = /^(\d{4})\s*[-/]\s*(\d{1,5})$/.exec(toWesternDigits(text).trim());
  return m ? `${m[1]}-${m[2].padStart(5, '0')}` : null;
}

/** Only an id's start was pasted (copied from a tag's short form). */
export const looksLikeShortId = (text: string) =>
  /^#?[0-9a-f]{8}$/i.test(text.trim()) && /[a-f]/i.test(text);
